import styled, { css } from 'styled-components';

const colors = (p) => {
  const { isPrimary, isDanger, isWhite } = p;

  let shadow;
  let shadowFocus;
  let fg;
  let fgHover;
  let bg;
  let bgHover;

  if (isPrimary) {
    fg = p.theme.colors.white;
    bg = p.theme.alias.primary;
    bgHover = p.theme.alias.primaryNext;
  } else if (isDanger) {
    fg = p.theme.colors.white;
    bg = p.theme.alias.danger;
    bgHover = p.theme.alias.dangerNext;
  } else {
    shadow = isWhite
      ? `${p.theme.space[0]} ${p.theme.space[0]} ${p.theme.space[0]} 1px ${p.theme.colors.white}`
      : p.theme.shadows.all;
    shadowFocus =
      isWhite &&
      `${p.theme.space[0]} ${p.theme.space[0]} ${p.theme.space[0]} 1px ${p.theme.alias.primary}, ${p.theme.space[0]} ${p.theme.space[0]} ${p.theme.space[0]} 2px ${p.theme.colors.white} !important`;
    fg = isWhite ? p.theme.colors.white : p.theme.alias.fg;
    fgHover = isWhite && p.theme.alias.primary;
    bg = 'transparent';
    bgHover = isWhite ? p.theme.colors.white : p.theme.alias.shadow;
  }

  return css`
    color: ${fg};
    box-shadow: ${shadow};
    background-color: ${bg};

    &:hover:not(:disabled) {
      color: ${fgHover};
      background-color: ${bgHover};
    }

    &:focus-visible {
      box-shadow: ${shadowFocus};
    }
  `;
};

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  width: ${(p) => p.isExtended && '100%'};
  padding: ${(p) => p.theme.space[2]} ${(p) => p.theme.space[5]};
  border-radius: ${(p) => p.theme.radii.pill};

  ${colors};

  &:disabled {
    opacity: 0.5;
  }

  &:focus-visible {
    box-shadow: ${(p) => p.theme.shadows.focusAlt};
  }
`;
